import {setQueryParam, deleteQueryParam} from 'src/utils/url';
import { catalogMat } from '../../utils/constants/signalmanConstants';

class Listing {
  constructor() {
    this.rePositionFeaturedProduct = this.rePositionFeaturedProduct.bind(this);
    this.filterChanged = this.filterChanged.bind(this);
    this.removeFilter = this.removeFilter.bind(this);
    this.filterChangedByLink = this.filterChangedByLink.bind(this);
    this.removeAllClicked = this.removeAllClicked.bind(this);
    this.turboBeforeCache = this.turboBeforeCache.bind(this);
    this.turboBeforeRender = this.turboBeforeRender.bind(this);
    this.filterGroupStates = {};
    window.onpopstate = function (event) {
      ProductCatalog.Listing.fetchStylesXhr(document.location.href);
    };
    this.initBehavior();
    this.reConstructor();
  }

  reConstructor() {
    this.internalCatalogShow();
    if (ProductCatalog.YdhTest) {
      ProductCatalog.YdhTest.init();
    }
    if (ProductCatalog.MasksPricing) {
      ProductCatalog.MasksPricing.init();
    }
    this.renderPriceTestDollars();
  }

  initBehavior() {
    $(document).on('click', '.pc-FiltersGroup-header', this.toggleFilterGroups);
    $(document).on(
      'click',
      '.pc-selectedFilters-removeAll a',
      this.removeAllClicked
    );
    $(document).on(
      'click',
      '.pc-selectedFilters-selectedFilter a',
      this.removeFilter
    );
    $(document).on('click', '.pc-FiltersGroup-link', this.filterChangedByLink);
    $(document).on(
      'change',
      '.pc-FiltersGroup-value input[type=checkbox]',
      this.filterChanged
    );
    enquire.register(StyleBitz.Layouts.sm, this.rePositionFeaturedProduct);
    document.addEventListener('turbolinks:before-cache', this.turboBeforeCache);
    return document.addEventListener(
      'turbolinks:before-render',
      this.turboBeforeRender
    );
  }

  rePositionFeaturedProduct() {
    const featuredProduct = $('.pc-ProductCard.is-featuredProduct');
    if (!featuredProduct.length) {
      return;
    }
    const productsReorderCount =
      parseInt(featuredProduct.data('style-position')) + 1;
    const productCards = $('.pc-ProductCard').slice(1, productsReorderCount);
    for (let index = 0; index < productCards.length; index++) {
      let productCard = productCards[index];
      productCard = $(productCard);
      productCard.css('order', index - productsReorderCount);
    }
    return featuredProduct.show();
  }

  toggleFilterGroups(e) {
    const filterHeader = $(e.target);
    const name = filterHeader.text().toLowerCase();
    let value = 'expanded';
    if (filterHeader.hasClass('expanded')) {
      value = 'collapse';
    }
    CustomInk.Metrics.fireEvent('catalog filter', name, value);
    filterHeader.next().slideToggle({
      duration: 300,
      // This by default uses display: block; which doesn't work for flex. That's what we use for colors filter group.
      // Respect the original computed style for this element instead of forcing a display: block; setting.
      start: function() { if ($(this).parents('.pc-FiltersGroup--colors').length) { $(this).css('display','flex') } },
      complete: function () { filterHeader.toggleClass('expanded') }
    });
  }

  internalCatalogShow() {
    const internalFlag = catalogMat;
    if (internalFlag === 'test') {
      $('.pc-FiltersGroup.is-Internal').show();
      return $('.pc-ProductCard-internalSearch').show();
    }
  }

  filterChanged(e) {
    const checkbox = $(e.target);
    this.filterChangedEvent(checkbox);
    const url = checkbox.siblings('.pc-FiltersGroup-link').first().attr('href');
    this.updateStyles(url);
  }

  removeFilter(e) {
    e.preventDefault();
    const $link = $(e.target);
    this.updateStyles($link.attr('href'));
  }

  filterChangedByLink(e) {
    e.preventDefault();
    let $link = $(e.target);
    if (!$link.is('.pc-FiltersGroup-link')) {
      $link = $link.parents('.pc-FiltersGroup-link');
    }
    const checkbox = $link.siblings('input[type=checkbox]').first();
    $(checkbox).prop('checked', !$(checkbox).is(':checked'));
    this.filterChangedEvent(checkbox);
    this.updateStyles($link.attr('href'));
  }

  filterChangedEvent(checkbox) {
    const name = $.trim(
      checkbox
        .closest('.pc-FiltersGroup')
        .find('.pc-FiltersGroup-header')
        .text()
        .toLowerCase()
    );
    const value = $.trim(
      checkbox
        .closest('label')
        .text()
        .replace(/\s?\(\d+\)/, '')
        .toLowerCase()
    );
    return CustomInk.Metrics.fireEvent('catalog filter', name, value);
  }

  removeAllClicked(e) {
    return CustomInk.Metrics.fireEvent('catalog filter', 'remove all');
  }

  turboBeforeCache(e) {
    const body = $(e.target.body);
    if (!body.length) {
      return;
    }
    return this.setFilterGroupsState(body);
  }

  turboBeforeRender(e) {
    const body = $(e.data.newBody);
    if (!body.length) {
      return;
    }
    return this.renderFilterGroupsState(body);
  }

  filterGroupStateKey(body) {
    body = body || $('body');
    return body.find('.pc-Styles').data('catid');
  }

  setFilterGroupsState(body) {
    const hdrs = body.find('.pc-FiltersGroup-header');
    if (!hdrs.length) {
      return;
    }
    const key = this.filterGroupStateKey(body);
    const states =
      this.filterGroupStates[key] || (this.filterGroupStates[key] = {});
    for (let hdr of Array.from(hdrs.toArray())) {
      const hdrEl = $(hdr);
      const name = hdrEl.text();
      const expanded = hdrEl.is('.expanded');
      states[name] = expanded;
      hdrEl.next().show();
      if (!expanded) {
        hdrEl.addClass('expanded');
      }
    }
    return (this.filterGroupStates[key] = states);
  }

  renderFilterGroupsState(body) {
    const hdrs = body.find('.pc-FiltersGroup-header');
    if (!hdrs.length) {
      return;
    }
    const key = this.filterGroupStateKey(body);
    const states = this.filterGroupStates[key];
    if (states == null) {
      return;
    }
    for (let hdr of Array.from(hdrs.toArray())) {
      const hdrEl = $(hdr);
      const name = hdrEl.text();
      const expanded = states[name];
      if (expanded !== undefined) {
        hdrEl.next().toggle(expanded);
        hdrEl.toggleClass('expanded', expanded);
      }
    }
    return undefined;
  }

  renderPriceTestDollars() {
    $('.flag-switch-dollar').each(function (_, node) {
      const $node = $(node);
      return $node.text($node.data('dollar'));
    });
    return undefined;
  }

  updateStyles(url) {
    // We don't want algolia to be querying mms and updating urls based on mms.
    // We want it to use its own index for pulling data
    if($('.algolia-listing-pages').length) {
      return;
    }
    history.pushState({}, null, url);
    this.fetchStylesXhr(url);
  }

  removeNoLayoutFromPagination() {
    $('.pc-Pagination-kaminari a').each((_index, element) => {
      const $link = $(element);
      const linkUrl = $link.attr('href');
      if (linkUrl !== undefined && linkUrl.indexOf('no_layout') !== -1) {
        $link.attr('href', deleteQueryParam('no_layout', linkUrl));
      }
    });
  }

  fetchStylesXhr(url, callback = function () {}) {
    // We don't want algolia to be querying mms and updating urls based on mms.
    // We want it to use its own index for pulling data
    if($('.algolia-listing-pages').length) {
      return;
    }
    return $.ajax({
      url: setQueryParam('no_layout', true, url)
    }).done(function (response, textStatus, jqXHR) {
      if (jqXHR.status === 200) {
        $('.pc-Styles').replaceWith(response);
        ProductCatalog.Listing.removeNoLayoutFromPagination();
        ProductCatalog.Cards.reConstructor();
        ProductCatalog.Listing.reConstructor();
        ProductCatalog.Toolbar.reConstructor();
        ProductCatalog.BulkSplitShipModal.reConstructor();
        callback();
      } else {
        $('.pc-Styles-products').html(
          '<div class="pc-NoResults--minimal">No results for current filters</div>'
        );
      }
    });
  }
}

jQuery(() => (ProductCatalog.Listing = new Listing()));
